import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      item: item.path ? `https://91guanwang.com${item.path}` : undefined,
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 py-4">
        <div className="max-w-6xl mx-auto">
          <ol className="flex items-center flex-wrap gap-1 text-sm">
            {items.map((item, index) => (
              <li key={index} className="flex items-center">
                {index > 0 && (
                  <div className="w-4 h-4 flex items-center justify-center mx-1">
                    <i className="ri-arrow-right-s-line text-xs text-foreground-400"></i>
                  </div>
                )}
                {item.path ? (
                  <Link
                    to={item.path}
                    className="text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {item.label}
                  </Link>
                ) : (
                  <span className="text-foreground-900 font-medium">{item.label}</span>
                )}
              </li>
            ))}
          </ol>
        </div>
      </nav>
    </>
  );
}